import { CampusClient } from "./campusClient"

export type UnlockableWeek = {
  sprintId: string
  weekNumber: number
  sprintTitle: string
  startDate: string
  endDate: string
}

export type UnlockableCourse = {
  courseTitle: string
  weeks: UnlockableWeek[]
}

export type UnlockableProgram = {
  programId: string | undefined
  offeringClientId: string
  syllabusName: string
  offeringStartDate: string
  courses: UnlockableCourse[]
}

export type UnlockableWeeksResponse = {
  programs: UnlockableProgram[]
}

export class ProgramManualUnlockClient {
  static async unlockNextSprint(
    userClientId: string,
    forceUnlock = true,
  ): Promise<void> {
    const url = `/manual-unlock/user/${userClientId}/sprint/next`
    const query = forceUnlock ? "?forceUnlock=true" : ""
    return CampusClient.put<void>(`${url}${query}`, {})
  }

  static unlockCourseNextWeek(
    userClientId: string,
    courseInstanceId: string,
  ): Promise<void> {
    const url = `/manual-unlock/user/${userClientId}/course/next`
    const query = `?courseInstanceId=${courseInstanceId}`
    return CampusClient.put<void>(`${url}${query}`, {})
  }

  static unlockNextWeekForAllRunningCourses(
    userClientId: string,
  ): Promise<void> {
    const url = `/manual-unlock/user/${userClientId}/courses/next`
    return CampusClient.put<void>(url, {})
  }

  static getUnlockableWeeks(
    userClientId: string,
  ): Promise<UnlockableWeeksResponse> {
    const url = `/manual-unlock/user/${userClientId}/unlockable-weeks`
    return CampusClient.get<UnlockableWeeksResponse>(url)
  }

  static unlockSprints(
    userClientId: string,
    sprintIds: string[],
  ): Promise<void> {
    const url = `/manual-unlock/user/${userClientId}/sprints`
    return CampusClient.put<void>(url, { sprintIds })
  }
}
